import * as types from './hourlyVolumeShareActionType';


export const fetchSiteHourlyVolumeShareUnReadDetailsRequest = (payload) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST,
    payload: payload
});
export const fetchSiteHourlyVolumeShareUnReadDetailsSuccess = (data) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_SUCCESS,
    payload: data
});
export const fetchSiteHourlyVolumeShareUnReadDetailsFailure = (error) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_FAILURE,
    payload: error
});

export const fetchSiteHourlyVolumeShareReadDetailsRequest = (payload) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST,
    payload: payload
});
export const fetchSiteHourlyVolumeShareReadDetailsSuccess = (data) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_SUCCESS,
    payload: data
});
export const fetchSiteHourlyVolumeShareReadDetailsFailure = (error) => ({
    type: types.FETCH_SITE_HOURLY_VOLUME_SHARE_READ_DETAILS_FAILURE,
    payload: error
});

export const exportSiteHourlyVolumeShareRequest = (data) => ({
    type: types.EXPORT_SITE_HOURLY_VOLUME_SHARE_REQUEST,
    payload: data
});
export const exportSiteHourlyVolumeShareSuccess = (data) => ({
    type: types.EXPORT_SITE_HOURLY_VOLUME_SHARE_SUCCESS,
    payload: data
});
export const exportSiteHourlyVolumeShareFailure = (error) => ({
    type: types.EXPORT_SITE_HOURLY_VOLUME_SHARE_FAILURE,
    payload: error
});

export const getDropdownSiteRadRequest = () => {
    const action = {
        type: types.GET_DROPDOWN_SITE_RAD_REQUEST
    };
    console.log('📦 Action Creator: getDropdownSiteRadRequest', action);
    console.log('🏷️ Action Type Value:', types.GET_DROPDOWN_SITE_RAD_REQUEST);
    return action;
};
export const getDropdownSiteRadSuccess = (data) => ({
    type: types.GET_DROPDOWN_SITE_RAD_SUCCESS,
    payload: data
});
export const getDropdownSiteRadFailure = (error) => ({
    type: types.GET_DROPDOWN_SITE_RAD_FAILURE,
    payload: error
});

export const getWorklistByRpceIdRequest = (rpceId) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_REQUEST,
    payload: rpceId
});
export const getWorklistByRpceIdSuccess = (data) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_SUCCESS,
    payload: data
});
export const getWorklistByRpceIdFailure = (error) => ({
    type: types.GET_WORKLIST_BY_RPCE_ID_FAILURE,
    payload: error
});

export const getPraticesByWorklistIdRequest = (worklistId) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_REQUEST,
    payload: worklistId
});
export const getPraticesByWorklistIdSuccess = (data) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_SUCCESS,
    payload: data
});
export const getPraticesByWorklistIdFailure = (error) => ({
    type: types.GET_PRATICES_BY_WORKLIST_ID_FAILURE,
    payload: error
});

export const getSubPraticesByPraticeIdRequest = (praticeId) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST,
    payload: praticeId
});
export const getSubPraticesByPraticeIdSuccess = (data) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_SUCCESS,
    payload: data
});
export const getSubPraticesByPraticeIdFailure = (error) => ({
    type: types.GET_SUB_PRATICES_BY_PRATICE_ID_FAILURE,
    payload: error
});
